module.exports = __webpack_public_path__ + "static/media/Potter.60c9a0d5.jpg";